import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckLoginGuard } from './shared/guards/check-login.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: ()=>import('./safil/safil.module').then(m=>m.SafilModule),
  },
  {
    path: 'login',
    loadChildren: ()=>import('./login/login.module').then(m=>m.LoginModule),
  },
  {
    path: 'menuaseg',
    loadChildren: ()=>import('./menuaseg/menuaseg.module').then(m=>m.MenuasegModule),
    canActivate:[CheckLoginGuard]
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
];
/*
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})*/
@NgModule({
  imports: [
    RouterModule.forRoot(routes, 
    {
      onSameUrlNavigation: 'reload',
      useHash: true,
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
